import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Role } from '../@core/constants';
import { UserFilter } from '../models/filters/user-filter';
import { Paging } from '../models/page';
import { ResponseModel } from '../models/response-model';
import { User } from '../models/user';
import { Filter } from './../models/filter';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private url = `${environment.url}/users`;
  constructor(private http: HttpClient) { }

  readUsersByRoleSupervisor(): Observable<ResponseModel<Paging<Array<User>>>> {
    let params = new HttpParams();
    params = params
      .set('role', Role.ROLE_SUPERVISOR)
      .set('page', '0')
      .set('pageSize', '1000');
    return this.http.get<ResponseModel<Paging<Array<User>>>>(this.url, {
      params,
    });
  }

  readUsers(
    filter: Filter<UserFilter>
  ): Observable<ResponseModel<Paging<Array<User>>>> {
    let params = new HttpParams()
      .set('page', `${filter.page}`)
      .set('pageSize', `${filter.pageSize}`)
      .set('branchCode', filter.value.branchCode!);

    if (filter.value.textFilter != undefined) {
      params = params.set('text', filter.value.textFilter);
    }

    return this.http.get<ResponseModel<Paging<Array<User>>>>(this.url, {
      params,
    });
  }

  readUser(userName: String) {
    return this.http.get<ResponseModel<User>>(`${this.url}/${userName}`);
  }
}
